module.exports = __webpack_public_path__ + "img/sign-up-reward-preview.480fbdbd.png";